module.exports = __webpack_public_path__ + "static/media/welcom-frame-img-1.78be1e09.jpg";